module.exports = "/fonts/fa-solid-900.eot?1056b521827390708dd3c2e140eb8533";